import { writeFile, utils } from 'xlsx'
// import * as alasql from 'alasql'
export const xlsxMixins = {
  methods: {
    exportToXLS (filename, { headers, items }) {
      const cloneHeaders = [...headers]
      const cloneItems = [...items]
      const exportItems = []
      cloneItems.forEach((element) => {
        const keys = Object.keys(element)
        console.log(keys)
      })
      cloneItems.forEach((element) => {
        const keys = Object.keys(element)
        const item = {}
        keys.forEach((sub) => {
          cloneHeaders.forEach((header) => {
            if (header.value === sub) {
              let value = element[sub]
              // Format timestamp columns to DD-MM-YYYY HH:mm
              if (sub.toLowerCase().includes('timestamp') && value) {
                const date = new Date(value)
                if (!isNaN(date.getTime())) {
                  const day = String(date.getDate()).padStart(2, '0')
                  const month = String(date.getMonth() + 1).padStart(2, '0')
                  const year = date.getFullYear()
                  const hours = String(date.getHours()).padStart(2, '0')
                  const minutes = String(date.getMinutes()).padStart(2, '0')
                  value = `${day}-${month}-${year} ${hours}:${minutes}`
                }
              }
              item[header.text] = value
            }
          })
        })

        exportItems.push(item)
      })

      const dataWS = utils.json_to_sheet(exportItems, { dateNF: 'dd-mm-yyyy HH:mm' })
      const wb = utils.book_new()
      utils.book_append_sheet(wb, dataWS)
      writeFile(wb, filename + '.xlsx')
    }
  }
}
